// src/data/products/msPipes.js
import steelPipesImg from '../../assets/images/ms-pipes.jpg';

export const msPipesData = {
  slug: 'ms-pipes',
  name: 'MS Pipes',
  image: steelPipesImg,
  description: 'Durable MS pipes for plumbing, structural, and mechanical applications, available in round and square variants.',
  subcategories: [
    {
      slug: 'ms-pipes',
      name: 'MS Pipes',
      description: 'MS pipes for general construction, water transport, and structural applications.',
      image: steelPipesImg,
      products: [
        {
          slug: 'ms-pipe-raipur',
          name: 'MS Pipe Raipur',
          image: steelPipesImg,
          shortDesc: 'High-quality MS pipes from Raipur steel mills.',
          description: 'MS Pipes from Raipur are manufactured with precision and quality control to ensure excellent performance in construction applications.',
          dimensions: [
            { size: '1/2 inch', thickness: '2.0mm', length: '6m', price: 'Price on Request' },
            { size: '3/4 inch', thickness: '2.0mm', length: '6m', price: 'Price on Request' },
            { size: '1 inch', thickness: '2.9mm', length: '6m', price: 'Price on Request' },
            { size: '1.5 inch', thickness: '3.2mm', length: '6m', price: 'Price on Request' },
            { size: '2 inch', thickness: '3.6mm', length: '6m', price: 'Price on Request' },
            { size: '3 inch', thickness: '4.0mm', length: '6m', price: 'Price on Request' },
            { size: '4 inch', thickness: '4.5mm', length: '6m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 1239)' },
            { property: 'Ends', value: 'Plain/Beveled/Threaded' },
            { property: 'Surface', value: 'Black/Galvanized' },
            { property: 'Tensile Strength', value: '320-510 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 215 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-pipe-raigarh',
          name: 'MS Pipe Raigarh',
          image: steelPipesImg,
          shortDesc: 'Reliable MS pipes from Raigarh steel mills.',
          description: 'MS Pipes from Raigarh offer excellent quality and performance for various construction and industrial applications.',
          dimensions: [
            { size: '1/2 inch', thickness: '2.0mm', length: '6m', price: 'Price on Request' },
            { size: '3/4 inch', thickness: '2.0mm', length: '6m', price: 'Price on Request' },
            { size: '1 inch', thickness: '2.9mm', length: '6m', price: 'Price on Request' },
            { size: '1.5 inch', thickness: '3.2mm', length: '6m', price: 'Price on Request' },
            { size: '2 inch', thickness: '3.6mm', length: '6m', price: 'Price on Request' },
            { size: '3 inch', thickness: '4.0mm', length: '6m', price: 'Price on Request' },
            { size: '4 inch', thickness: '4.5mm', length: '6m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 1239)' },
            { property: 'Ends', value: 'Plain/Beveled/Threaded' },
            { property: 'Surface', value: 'Black/Galvanized' },
            { property: 'Tensile Strength', value: '320-510 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 215 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-square-pipe',
          name: 'MS Square Pipe',
          image: steelPipesImg,
          shortDesc: 'Square MS pipes for structural and fabrication applications.',
          description: 'MS Square Pipes are manufactured with precision for structural applications, frames, and fabrication work. These pipes offer excellent dimensional accuracy and strength.',
          dimensions: [
            { size: '20x20mm', thickness: '1.2mm', length: '6m', price: 'Price on Request' },
            { size: '25x25mm', thickness: '1.5mm', length: '6m', price: 'Price on Request' },
            { size: '40x40mm', thickness: '2.0mm', length: '6m', price: 'Price on Request' },
            { size: '50x50mm', thickness: '2.5mm', length: '6m', price: 'Price on Request' },
            { size: '60x60mm', thickness: '3.0mm', length: '6m', price: 'Price on Request' },
            { size: '80x80mm', thickness: '3.2mm', length: '6m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 4923)' },
            { property: 'Shape', value: 'Square' },
            { property: 'Surface', value: 'Black/Galvanized' },
            { property: 'Tensile Strength', value: '320-510 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 215 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-round-pipe',
          name: 'MS Round Pipe',
          image: steelPipesImg,
          shortDesc: 'Round MS pipes for plumbing and general applications.',
          description: 'MS Round Pipes are manufactured for various applications including plumbing, water supply, and general construction. These pipes offer excellent corrosion resistance when galvanized.',
          dimensions: [
            { size: '1/2 inch', thickness: '2.0mm', length: '6m', price: 'Price on Request' },
            { size: '3/4 inch', thickness: '2.3mm', length: '6m', price: 'Price on Request' },
            { size: '1 inch', thickness: '2.9mm', length: '6m', price: 'Price on Request' },
            { size: '1.25 inch', thickness: '3.2mm', length: '6m', price: 'Price on Request' },
            { size: '1.5 inch', thickness: '3.2mm', length: '6m', price: 'Price on Request' },
            { size: '2 inch', thickness: '3.6mm', length: '6m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 1239)' },
            { property: 'Shape', value: 'Round' },
            { property: 'Surface', value: 'Black/Galvanized' },
            { property: 'Tensile Strength', value: '320-510 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 215 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        }
      ]
    }
  ]
};
